(function () {
  angular.module("akitabox.ui.components.treeInput", [
    "akitabox.core.utils",
    "akitabox.core.services.tree",
  ]);
})();
